const steps = [
  { num: '1', title: 'Диагностика', desc: 'Изучаем типичные управленческие ситуации и проблемы участников: с какими сложными разговорами сталкиваются, как обычно дают обратную связь, где возникают трудности.' },
  { num: '2', title: 'Инструменты', desc: 'Разбираем конкретные модели и алгоритмы проведения разговоров: как готовиться, как начинать, как удерживать конструктивный тон, как завершать договорённостью.' },
  { num: '3', title: 'Демонстрация', desc: 'Показываем, как может выглядеть разговор руководителя с сотрудником в разных ситуациях — от обсуждения ошибки до сложного разговора о невыполнении задач.' },
  { num: '4', title: 'Отработка', desc: 'Участники тренируются на ролевых ситуациях: проводят сложные разговоры, получают опыт в безопасной среде, пробуют разные подходы.' },
  { num: '5', title: 'Разбор', desc: 'Получают обратную связь по своей коммуникации: что сработало, что можно улучшить, как усилить воздействие на собеседника.' },
  { num: '6', title: 'Реальные кейсы', desc: 'Разбираем ситуации участников и компании. Вместо абстрактных упражнений работаем с теми сложными разговорами, которые руководителям действительно предстоит провести.' },
  { num: '7', title: 'Внедрение', desc: 'Формируем конкретные действия для использования инструментов после обучения: кто, когда и с кем проведёт разговор, как подготовиться.' },
  { num: '8', title: 'Сопровождение', desc: 'Разбираем реальные разговоры и сложные ситуации после тренинга: что получилось, где возникли трудности, как скорректировать подход.' },
];

export default function HowTrainingGoes() {
  return (
    <section id="process" className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Как проходит тренинг
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Практический формат обучения: от диагностики до сопровождения — восемь этапов, обеспечивающих реальное изменение управленческих коммуникаций
        </p>

        <div className="relative">
          <div className="hidden lg:block absolute left-[23px] top-8 bottom-8 w-0.5 bg-teal-200"></div>
          <div className="space-y-5">
            {steps.map((step) => (
              <div key={step.num} className="flex gap-5 items-start relative">
                <div className="w-12 h-12 rounded-full bg-teal-600 text-white flex items-center justify-center text-lg font-bold flex-shrink-0 z-10">
                  {step.num}
                </div>
                <div className="bg-white rounded-xl border border-gray-200 p-4 md:p-5 flex-1 hover:border-teal-300 transition-colors">
                  <h3 className="font-bold text-gray-900 text-sm mb-1.5">{step.title}</h3>
                  <p className="text-gray-600 text-xs leading-relaxed">{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}